import { AppCardListWidget as ComponentLibraryAppCardListWidget } from '@orcha/micro-library-widgets-ui';

import AppCard from 'src/components/AppCard';
import ClientSideDataFetcher from 'src/components/AppCard/AppCardWrapper/ClientSideDataWrapper';
import IAppCardAppData from '@orcha/types/app-card-app-data';
import { AppCardListWidgetConfiguration } from './AppCardListWidget.configuration';

const DEFAULT_APP_CARD_LIMIT = 9;

export type AppCardListWidgetProps = AppCardListWidgetConfiguration & {
  apps?: IAppCardAppData[];
  hideImages?: boolean; // this is used for cypress testing
};

const AppCardListWidget = ({
  apps,
  items,
  appCardLimit,
  title,
  hideImages,
  styleOverrides,
}: AppCardListWidgetProps) => {
  const appsWithLimitApplied = apps?.slice(
    0,
    appCardLimit ?? DEFAULT_APP_CARD_LIMIT
  );

  return (
    <ComponentLibraryAppCardListWidget
      data-testid="apps-widget-container"
      title={title}
      styleOverrides={styleOverrides}
    >
      {items && items.length > 0
        ? // if items is provided, render ClientSideDataFetcher for each appId
          items.map((item) => {
            return (
              <ClientSideDataFetcher
                key={item.appId}
                appId={item.appId}
                hideImages={hideImages}
              />
            );
          })
        : appsWithLimitApplied?.map((appData) => {
            return (
              <AppCard
                appData={appData}
                key={appData.appId}
                hideImages={hideImages}
              />
            );
          })}
    </ComponentLibraryAppCardListWidget>
  );
};

export default AppCardListWidget;
